import React from "react";
import BoardCardShell from "../BoardCardShell";
import BoardChartRegion from "../BoardChartRegion";
import BoardCardState from "../BoardCardState";
import FlowVisualization from "features/analytics/studio/components/charts/FlowVisualization";

// Badge uses brand-primary token — adapts to both light and dark themes
const BADGE = {
  label: "Flow",
  bg: "color-mix(in srgb, var(--brand-primary) 10%, transparent)",
  color: "var(--brand-primary)",
};

export default function FlowBoardCard({ card, result, onEdit, onDelete, readOnly }) {
  const flowData = result?.data?.nodes ? result.data : result?.data?.data || null;
  const anchorEvents = card?.queryDsl?.definition?.anchorEvents || [];

  const actions = readOnly ? [] : [
    ...(onEdit ? [{ label: "Edit", icon: "edit_pencil", onClick: onEdit }] : []),
    ...(onDelete ? [{ label: "Delete", icon: "delete", onClick: onDelete, danger: true }] : []),
  ];

  const state = !result
    ? "loading"
    : result.error
    ? "error"
    : !flowData?.nodes?.length
    ? "empty"
    : null;
  const errorMsg = typeof result?.error === "string" ? result.error : "Could not load flow";

  return (
    <BoardCardShell
      title={card?.title || "Flow"}
      badge={BADGE}
      actions={actions}
      readOnly={readOnly}
    >
      {state ? (
        <BoardCardState state={state} message={state === "error" ? errorMsg : "No flow data"} />
      ) : (
        <BoardChartRegion>
          {({ height }) => (
            <FlowVisualization
              data={flowData}
              height={Math.max(120, height)}
              flowAnchorEvents={anchorEvents}
            />
          )}
        </BoardChartRegion>
      )}
    </BoardCardShell>
  );
}
